import { ActionTypes, ReduxAction } from './types';

import { Dispatch } from 'redux';
import { LademittelService } from '../../api';

export const getLademittel =
  (mandantId: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new LademittelService().getLademittel(mandantId).then(result => {
      dispatch({
        type: ActionTypes.GET_LADEMITTEL,
        payload: result.data,
      });
    });
  };

export const getLademittelOnlyGGVSOrWithout =
  (mandantId: number, isGGVS: boolean | undefined) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new LademittelService()
      .getLademittelOnlyGGVSOrWithout(mandantId, isGGVS)
      .then(result => {
        dispatch({
          type: ActionTypes.GET_LADEMITTEL,
          payload: result.data,
        });
      });
  };
